var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Rbn pageBox"},[_c('check-code',{attrs:{"info":_vm.info},on:{"startBind":_vm.startBind}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }